export class FsxOntapVolume {
    'volumeId';
    'name';
    'sizeBytes';
    'junctionPath';
    'storageVirtualMachineId';
    'volumeType';
    'securityStyle';
    'storageEfficiencyEnabled';
    'snapshotPolicy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "junctionPath",
            "baseName": "junctionPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageVirtualMachineId",
            "baseName": "storageVirtualMachineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeType",
            "baseName": "volumeType",
            "type": "FsxOntapVolumeVolumeTypeEnum",
            "format": ""
        },
        {
            "name": "securityStyle",
            "baseName": "securityStyle",
            "type": "FsxOntapVolumeSecurityStyleEnum",
            "format": ""
        },
        {
            "name": "storageEfficiencyEnabled",
            "baseName": "storageEfficiencyEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotPolicy",
            "baseName": "snapshotPolicy",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FsxOntapVolume.attributeTypeMap;
    }
    constructor() {
    }
}
export var FsxOntapVolumeVolumeTypeEnum;
(function (FsxOntapVolumeVolumeTypeEnum) {
    FsxOntapVolumeVolumeTypeEnum["Rw"] = "RW";
    FsxOntapVolumeVolumeTypeEnum["Dp"] = "DP";
})(FsxOntapVolumeVolumeTypeEnum || (FsxOntapVolumeVolumeTypeEnum = {}));
export var FsxOntapVolumeSecurityStyleEnum;
(function (FsxOntapVolumeSecurityStyleEnum) {
    FsxOntapVolumeSecurityStyleEnum["Unix"] = "UNIX";
    FsxOntapVolumeSecurityStyleEnum["Ntfs"] = "NTFS";
    FsxOntapVolumeSecurityStyleEnum["Mixed"] = "MIXED";
})(FsxOntapVolumeSecurityStyleEnum || (FsxOntapVolumeSecurityStyleEnum = {}));
